import { Component, input } from '@angular/core';

export enum ChipsType {
    Default = 'default',
    LightBlue = 'light-blue',
    DarkBlue = 'dark-blue'
}

@Component({
    selector: 'chips-component',
    templateUrl: './chips.component.html',
    styleUrls: ['./chips.component.scss'],
    standalone: false
})
export class ChipsComponent {
    public type = input<ChipsType>(ChipsType.Default);

    public hover = input<boolean>(false);
}
